
import Vue from "vue";
import { mapGetters } from "vuex";

export default Vue.extend({
  name: "component-filter-list",
  props: {
    isMobile: Boolean,
    isSearchAgain: Boolean,
    tuneTextOn: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters("data", ["isNotNormalMap"]),
  },
  directives: {
    // reset horizontal scroll to the very left
    resetScroll: {
      update(el) {
        el.scrollLeft = 0;
      },
    },
  },
});
